import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Add.module.css'  
import MultiSelect from '../../../UI/Inputs/MultiSelect';
import { AppContext } from '../../../../providers/appProvider';
import { selectStyle } from './selectStyle'; 
import Form from '../../../../assets/Style/Form.module.css'
import Select from "react-select"; 
import { useTranslation } from 'react-i18next';
import Plus from "../../../../assets/Icon/Plus";

const AddOne = ({ transportPriceService, defaultTransportPrice }) => {
    const {t} = useTranslation();
    
    const transportPriceResetData = {
        id: 0,
        name: "",
    }

    const initEditPrice = (transportPrice) => {
        return {
            id: 0,
            name: "",
            company_price: 0,
            saler_price: 0,
            internal_price: 0,

            sender_country_id:  0,
            sender_city_id:  0,
            reciever_country_id:  0,
            reciever_city_id: 0,
            location_country_id: 0,
            location_city_id:  0,
            website_id: 0, 

        }
    }

    const { appState, app } = useContext(AppContext);
    const websites = appState.websites.map((website) => ({ value: website.id, label: website.name })); 

    const [newPrice, setNewPrice] = useState(initEditPrice(null))
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const validatePrice = (transportPrice) => {
        const messages = {};

        if (transportPrice.sender_country_id < 1) {
            messages.sender_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (transportPrice.sender_city_id < 1) {
            messages.sender_city_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (transportPrice.reciever_country_id < 1) {
            messages.reciever_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (transportPrice.reciever_city_id < 1) {
            messages.reciever_city_id = { message: 'სავალდებულოა', isValid: false };
        }

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    const reValidate = () => {
        const isValidate = validatePrice(newPrice)

    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validatePrice(newPrice)
        }
    }, [newPrice, isFirstValidated]);

  

    const [isModalOpen, setIsModalOpen] = useState(false);

    const saveHandle = () => {

        const isValidate = validatePrice(newPrice)

        if (isValidate === true) {
            transportPriceService.addone(newPrice)
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true)
        }
 
    };
 
    const handlePriceIntChange = async (event) => {
        let val = convertToInt(event.target.value);
        setNewPrice(prevPrice => ({
            ...prevPrice,
            [event.target.name]: val
        }));
    };

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true)
        setIsFirstValidated(false)
    }


    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; // Regular expression to match only numeric characters

        if (!regex.test(keyValue)) {
            event.preventDefault();
        }
    };

    const stylesError = { 
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)', // Apply blue border on hover if focused, otherwise regular border
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),    
    };


    return (
        <div>

            <span className={ cl.AddBtn } onClick={() => openAdd()} >
                <span className={cl.icon}><Plus /></span>

                 {t('Add')}
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
 
                <div className={cl.modalHead} >
                    <h3><span className={cl.iconHead} > <Plus /></span> {t('Add')}</h3>
                </div>

            

                <fieldset className={cl.formField}>
                        <legend>{t('Location')}</legend>
                        
                            <MultiSelect
                                parentOptions={appState.countries}
                                childOptions={appState.cities}
                                parentId={newPrice.location_country_id}
                                childId={newPrice.location_city_id}
                                isNetwork={true}
                                styles={selectStyle}
                                onChange={async (location_country_id,location_city_id) => {
                                    setNewPrice(prevState => ({
                                        ...prevState,
                                        location_country_id: location_country_id ? location_country_id : 0,
                                        location_city_id: location_city_id ? location_city_id : 0,
                                    }))
                                }}
                                join={"country_id"}
                                placeholder={t('Country')}
                                placeholderSub={t('Port')}
                                validate={validates && validates.location_country_id ? true : false}
                                validateSub={validates && validates.location_city_id ? true : false}
                            />
                 </fieldset>


                <fieldset className={cl.formField}>
                    <legend>{t('Loading')}</legend>
                    
                        <MultiSelect
                            parentOptions={appState.countries}
                            childOptions={appState.cities}
                            parentId={newPrice.sender_country_id}
                            childId={newPrice.sender_city_id}
                            isNetwork={true}
                            styles={selectStyle}
                            onChange={async (sender_country_id, sender_city_id) => {
                                setNewPrice(prevState => ({
                                    ...prevState,
                                    sender_country_id: sender_country_id ? sender_country_id : 0,
                                    sender_city_id: sender_city_id ? sender_city_id : 0,
                                }))
                            }}
                            join={"country_id"}
                            placeholder={t('Country')}
                            placeholderSub={t('Port')}
                            validate={validates && validates.sender_country_id ? true : false}
                            validateSub={validates && validates.sender_city_id ? true : false}
                        />
                        
                </fieldset>



                <fieldset className={cl.formField}>
                    <legend>{t('ReceivingPort')}</legend>

                        <MultiSelect
                            parentOptions={appState.countries}
                            childOptions={appState.cities}
                            parentId={newPrice.reciever_country_id}
                            childId={newPrice.reciever_city_id}
                            isNetwork={true}
                            styles={selectStyle}
                            onChange={async (reciever_country_id, reciever_city_id) => { 
                                setNewPrice(prevState => ({
                                    ...prevState,
                                    reciever_country_id: reciever_country_id ? reciever_country_id : 0,
                                    reciever_city_id: reciever_city_id ? reciever_city_id : 0,
                                }))
                            }}
                            join={"country_id"}
                            placeholder={t('Country')}
                            placeholderSub={t('Port')}
                            validate={validates && validates.reciever_country_id ? true : false}
                            validateSub={validates && validates.reciever_city_id ? true : false}
                        />


                </fieldset>

                <fieldset className={cl.formField}>
                <legend>{t('WebSite')}</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={validates && validates.website_id ? { ...selectStyle, ...stylesError } : selectStyle}
                            options={websites}
                            value={websites.find(option => option.value === newPrice.website_id)}
                            onChange={(selectedOption) => {
                                setNewPrice(prevState => ({
                                    ...prevState,
                                    website_id: selectedOption ? selectedOption.value : 0,
                                }));
                            }}
                            placeholder={t('WebSite')}
                        />


                    </div>
                </fieldset>


                <div className={ cl.groupPrice }>
                    <label className={ cl.leftLabel }>{t('ContainerPrice')}</label>
                    <div className={ cl.rightInput }>
                        <div className={ Form.priceInput }> 
                            <div className={ Form.priceCurrency }> 
                                USD
                            </div>
                            <input type="text" onKeyPress={handleKeyPress} name="company_price" className={ Form.input } value={newPrice.company_price} onChange={handlePriceIntChange} min="0"/>
                            <div className={ Form.hundred } >.00</div>
                        </div>
                    </div>
                </div>


                <div className={ cl.groupPrice }>
                    <label className={ cl.leftLabel }>{t('InternalTransportation')}</label>
                    <div className={ cl.rightInput }>
                        <div className={ Form.priceInput }> 
                            <div className={ Form.priceCurrency }>USD</div>
                            <input type="text" onKeyPress={handleKeyPress} name="internal_price" className={ Form.input } value={newPrice.internal_price} onChange={handlePriceIntChange} min="0"/>
                            <div className={ Form.hundred } >.00</div>
                        </div>
                    </div>
                </div>
                
  
  
 
                <span onClick={saveHandle} className={cl.btnPrimary}>{t('Add')}</span>
            </Modal>
        </div>
    );
};

export default AddOne;